import { render, staticRenderFns } from "./absent-list-add.vue?vue&type=template&id=2039e062&scoped=true&"
import script from "./absent-list-add.vue?vue&type=script&lang=js&"
export * from "./absent-list-add.vue?vue&type=script&lang=js&"
import style0 from "./absent-list-add.vue?vue&type=style&index=0&id=2039e062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2039e062",
  null
  
)

export default component.exports